export function ExtensibleIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C12 1.46957 12.2107 0.960859 12.5858 0.585786C12.9609 0.210714 13.4696 0 14 0C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V4H20V2C20 1.46957 20.2107 0.960859 20.5858 0.585786C20.9609 0.210714 21.4696 0 22 0C22.5304 0 23.0391 0.210714 23.4142 0.585786C23.7893 0.960859 24 1.46957 24 2V4H28C29.0609 4 30.0783 4.42143 30.8284 5.17157C31.5786 5.92172 32 6.93913 32 8V12H34C34.5304 12 35.0391 12.2107 35.4142 12.5858C35.7893 12.9609 36 13.4696 36 14C36 14.5304 35.7893 15.0391 35.4142 15.4142C35.0391 15.7893 34.5304 16 34 16H32V20H34C34.5304 20 35.0391 20.2107 35.4142 20.5858C35.7893 20.9609 36 21.4696 36 22C36 22.5304 35.7893 23.0391 35.4142 23.4142C35.0391 23.7893 34.5304 24 34 24H32V28C32 29.0609 31.5786 30.0783 30.8284 30.8284C30.0783 31.5786 29.0609 32 28 32H24V34C24 34.5304 23.7893 35.0391 23.4142 35.4142C23.0391 35.7893 22.5304 36 22 36C21.4696 36 20.9609 35.7893 20.5858 35.4142C20.2107 35.0391 20 34.5304 20 34V32H16V34C16 34.5304 15.7893 35.0391 15.4142 35.4142C15.0391 35.7893 14.5304 36 14 36C13.4696 36 12.9609 35.7893 12.5858 35.4142C12.2107 35.0391 12 34.5304 12 34V32H8C6.93913 32 5.92172 31.5786 5.17157 30.8284C4.42143 30.0783 4 29.0609 4 28V24H2C1.46957 24 0.960859 23.7893 0.585786 23.4142C0.210714 23.0391 0 22.5304 0 22C0 21.4696 0.210714 20.9609 0.585786 20.5858C0.960859 20.2107 1.46957 20 2 20H4V16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14C0 13.4696 0.210714 12.9609 0.585786 12.5858C0.960859 12.2107 1.46957 12 2 12H4V8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42143 6.93913 4 8 4H12V2ZM8 8H28V28H8V8Z"
        fill="url(#paint0_radial_559_3245)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_559_3245"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-157 -285) scale(389 389.001)"
        >
          <stop stopColor="#FF00FF" />
          <stop offset="1" stopColor="#734CE2" />
        </radialGradient>
      </defs>
    </svg>
  )
}
